import api from '@/utils/api';
import {
    GET_LIST_DOCTOR_APPOINTMENTS,
    GET_DOCTOR_APPOINTMENTS_STATISTICS

} from './types';
import { NotificationManager } from 'react-notifications';

export const getListDoctorAppointments = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/doctor-appointments', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_DOCTOR_APPOINTMENTS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}


export const getListDoctorAppointmentsStatistics = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/doctor-appointments/statistics', { params: filter })
            .then(res => {
                dispatch({
                    type: GET_DOCTOR_APPOINTMENTS_STATISTICS,
                    payload: res.data.data || {},
                });
                resolve(res.data.data || {});
            })
            .catch(err => {
                NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
                reject(err);
            });
    });
};